import * as React from "react";
import { auth } from "../firebase";
import { Redirect, withRouter } from "react-router";

export interface IAuthContext {
	isLoggedIn: boolean;
	userId: string;
}
export const AuthContext = React.createContext<IAuthContext>({
	isLoggedIn: false,
	userId: ''
});

const { Provider, Consumer } = AuthContext;
class AuthProvider extends React.Component {
	state = {
		isLoggedIn: false,
		userId: ''
	};

	componentDidMount() {
		//Register a listener
		auth.onAuthStateChanged(user => {
			if (user) {
				console.log(user);
				this.setState({ isLoggedIn: true, userId: user.uid });
			} else {
				this.setState({ isLoggedIn: false, userId: user.uid });
			}
		});
	}
	static Consumer = Consumer;

	render() {
		return <Provider value={this.state}>{this.props.children}</Provider>;
	}
}

export default AuthProvider;

export interface AuthProps {
	authDetails: IAuthContext;
}

//HOC
export function withAuth(Component) {
	return function WithAuthComponent(props) {
		return (
			<Consumer>
				{authInfo => <Component {...props} authDetails={authInfo} />}
			</Consumer>
		);
	};
}

export function LoggedInRedirect(Component) {
	return function WithLoggedInRedirect(props) {
		return (
			<Consumer>
				{authInfo =>
					authInfo.isLoggedIn ? (
						<Redirect to={"/"} />
					) : (
						<Component {...props} />
					)
				}
			</Consumer>
		);
	};
}



// WEBPACK FOOTER //
// ./src/helpers/WithLoggedIn.tsx